import { queryOptions } from '@tanstack/react-query';

import { mockGymFinderService } from 'app/features/leads/services/gym-finder';

export const leadDetailQueryOptions = (leadId: string) =>
  queryOptions({
    queryKey: ['leads', 'detail', leadId],
    queryFn: () => mockGymFinderService.getLead(leadId),
    refetchOnWindowFocus: false,
  });
